// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"th_a bhs_b bhs_bj","SubscribedPhotoblogs__link":"th_b bhs_a bhs_r"};